const FormSpinner = () => (
    <div className='eh-card-block eh-form-loading'>
        <div className='ar-spinner' />
    </div>
);

export default FormSpinner;
